export var DIP_CALLBACK_CONTEXT = 'dip_callback';
export var PM_INLINE_ERROR_CODE = 'PM-003';
export var ADD_ITEM_FAILED = 'Add Item Failed';
export var PLACE_ORDER_FAILED = 'Place Order Failed';
export var PAYMENT_ERROR_ON_REVIEW = 'Error on Payment step of Review';
export var REPLACE_ITEM_FAILED = 'Replace Item Failed';
export var DIP_WRAPPER_TESTID = 'DIP_WRAPPER';
export var CustomCommandNames = /*#__PURE__*/function (CustomCommandNames) {
  CustomCommandNames["APP_MODE_CHANGED"] = "APP_MODE_CHANGED";
  CustomCommandNames["MOP_SELECTED"] = "MOP_SELECTED";
  return CustomCommandNames;
}({});
export var PaymentMethods = /*#__PURE__*/function (PaymentMethods) {
  PaymentMethods["ApplePay"] = "applepay";
  PaymentMethods["CreditCard"] = "creditcard";
  PaymentMethods["PayPal"] = "paypal";
  PaymentMethods["Yiftee"] = "yiftee";
  PaymentMethods["Venmo"] = "venmo";
  PaymentMethods["GooglePay"] = "GOOGLE_PAY";
  return PaymentMethods;
}({});
export var AppMode = /*#__PURE__*/function (AppMode) {
  AppMode["LOADING"] = "LOADING";
  AppMode["DEFAULT_MOP"] = "DEFAULT_MOP";
  AppMode["LIST_MOPS"] = "LIST_MOPS";
  AppMode["EDIT"] = "EDIT";
  AppMode["ADD"] = "ADD";
  AppMode["VERIFY_3RD_PARTY_ADDRESS"] = "VERIFY_3RD_PARTY_ADDRESS";
  AppMode["YIFTEE_FULL_COVERAGE"] = "YIFTEE_FULL_COVERAGE";
  AppMode["REVIEW_MOP"] = "REVIEW_MOP";
  return AppMode;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/DropInPayments/constants.js
// module id = 488
// module chunks = 11